/**
 * Compares the active acting-on-behalf-of with the required ones.
 * If `required` is nullish or empty, true is returned.
 * If `active` is nullish or empty, required must be nullish or empty as well.
 * If `required` is not empty, all the JWT's acting-on-behalf-of (normally just 1)
 * must match at least one of the given `required`.
 * @param baforPrefixes list of BAFOR prefixes in actingOnBehalfOf
 * @returns true if condition fulfilled
 */
export const checkActingOnBehalfOf = (active, required) => {
    if (!required || !required.length) {
        // Caller doesn't care for actingOnBehalfOf
        return true;
    }
    if (!active || active.length === 0) {
        // only fine as long as explicitly no BaforPattern wanted
        return required.length === 0;
    }
    let matchAnyWantedPattern = false;
    for (const req of required) {
        let matchAllBehalfsToWanted = true;
        for (const act of active) {
            matchAllBehalfsToWanted && (matchAllBehalfsToWanted = act.startsWith(req));
        }
        matchAnyWantedPattern || (matchAnyWantedPattern = matchAllBehalfsToWanted);
    }
    return matchAnyWantedPattern;
};
/**
 * Checks whether the active acting-type is listed in `required`.
 * If `required` is nullish, this check is skipped and true is returned.
 * If `required` is empty, `active` must be nullish.
 * @param active the active/actual/current acting-type of the JWT
 * @param required the acting-type to compare against
 * @returns true in case of a match
 */
export const checkActingType = (active, required) => {
    if (!required) {
        // caller appearently doesn't care.
        return true;
    }
    if (!active) {
        // No acting-type is only fine of explicitly none is wanted
        return required.length === 0;
    }
    return required.includes(active);
};
/**
 * Compare the actuve authn-level with `required` and return whether it is at least as high.
 * If no authn-level is required (`!required`), true is returned.
 * @param active the active/actual/current authentication level
 * @param required the required minimum authentication level
 * @returns true if at least this level is present
 */
export const checkAuthnLevel = (active, required) => {
    if (!required) {
        return true;
    }
    if (active == null) {
        return false;
    }
    if (active === required) {
        return true;
    }
    // this only works as long as the AuthnLevels' hierarchy corresponds to their alphabetic order
    return active >= required;
};
